import { createReguideContext } from 'reguide';

export const GUIDE_STEPS = {
  WELCOME: 'WELCOME',
  HELP_GUIDE: 'HELP_GUIDE',
  NAVIGATION_DESKTOP: 'NAVIGATION_DESKTOP',
  NAVIGATION_MOBILE: 'NAVIGATION_MOBILE',
  SEARCH: 'SEARCH',
  SCENARIO_CARDS: 'SCENARIO_CARDS',
  SCENARIO_PREVIEW: 'SCENARIO_PREVIEW',
  SESSION_CREATE: 'SESSION_CREATE',
  SCENARIO_LAUNCH: 'SCENARIO_LAUNCH',
} as const;

export type DashboardGuideTargetId =
  (typeof GUIDE_STEPS)[keyof typeof GUIDE_STEPS];

export const reguideContext = createReguideContext<DashboardGuideTargetId>();

export const { useReguide, useTarget: useReguideTarget } = reguideContext;
